/**
 * 线上环境
 */
export const ONLINEHOST_FW = 'http://fw.zhichenghui.org.cn/index.php'
export const ONLINEHOST_YXB = 'http://yxb.zccfpt.org.cn/index.php'
/**
 * 测试环境
 */
export const QAHOST_FW = 'http://fw.zhichenghui.org.cn/index.php'
export const QAHOST_YXB = 'http://yxb.zccfpt.org.cn/index.php'

export const BASE_URL_FW = process.env.NODE_ENV === 'production' ? ONLINEHOST_FW : QAHOST_FW
export const BASE_URL_YXB = process.env.NODE_ENV === 'production' ? ONLINEHOST_YXB : QAHOST_YXB

//请求类型判断
export const REQUEST_TYPE_FW  = 'REQUEST_TYPE_FW'
export const REQUEST_TYPE_YXB = 'REQUEST_TYPE_YXB'

//文件地址
export const FILE_PATH_FW=  `http://fw.zhichenghui.org.cn`
export const FILE_PATH_YXB=  `${BASE_URL_YXB}`

//文件上传地址
export const FILE_UPLOAD_HOST_FW = `${BASE_URL_YXB}Index/Other/upload`
export const FILE_UPLOAD_HOST = 'http://upload-z2.qiniup.com/'


/*
* 百度编辑器配置
* */
export const bdEditConfig = () => {
    return {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 320,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: requestUrl + '/editor/controller.php',
        serverUrl:  'http://yxb.zccfpt.org.cn/editor/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
    }
}


/*
* 缓存字段
* */
export const localAnStore = [
    {
        key: 'token',
        type: 'localStorage'
    },
    {
        key: 'user',
        type: 'localStorage'
    },
    {
        key: 'emofUserTokenSafer',
        type: 'localStorage'
    }
]
